export class TopSlider {
	imageAlt?: string;
	imageUrl = '';
	actionUrl?: string;

	constructor(imageUrl: string, imageAlt?: string, actionUrl?: string) {
		this.imageAlt = imageAlt;
		this.imageUrl = imageUrl;
		this.actionUrl = actionUrl;
	}
}
